import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import VibeComparison from '../components/VibeComparison';
import ContentDisplay from '../components/ContentDisplay';

const EnhancePage = ({ variant = 'light' }) => {
  const { t } = useTranslation();
  
  const tabData = {
    id: 'enhance',
    label: t('navigation.enhance'),
    title: t('pages.enhance.title'),
    subtitle: t('pages.enhance.subtitle')
  };

  return (
    <motion.div 
      className="container mx-auto px-4 py-6 lg:py-10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.6 }}
    >
      {/* 文字说明区域 */}
      <div className="mb-8 lg:mb-12">
        <ContentDisplay activeTab="enhance" tabData={[tabData]} variant={variant} />
      </div>

      {/* 图片对比区域 */}
      <div className="mb-6 lg:mb-8">
        <VibeComparison className="w-full" />
      </div>
    </motion.div>
  );
};

export default EnhancePage;